import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import "./Counters.css";

export default function Counters() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const counters = [
    { value: 100, suffix: "+", label: "Successful Campaigns", icon: "📈" },
    { value: 200, suffix: "+", label: "Happy Clients", icon: "😊" },
    { value: 25, suffix: "+", label: "Platforms Covered", icon: "🌐" },
    { value: 300, suffix: "%", label: "ROI Growth", icon: "💰" },
  ];

  return (
    <section className="counters-section" ref={ref}>
      <div className="counters-container">
        {counters.map((item, index) => (
          <div className="counter-card" key={index}>
            <div className="counter-icon">{item.icon}</div>
            <h3 className="counter-value">
              {inView && (
                <CountUp
                  start={0}
                  end={item.value}
                  duration={2.5}
                  suffix={item.suffix}
                />
              )}
            </h3>
            <p className="counter-label">{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
